var exports = {
  "h": "x31de4314--1687d4--suggestion",
};

module.exports = exports;
